import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SignaturePadComponent } from '../../signature-pad/signature-pad.component';
//import { FormDataService } from '../../../Services/Form Data /form-data.service';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { FormDataService } from '../../../Services/Form Data/form-data.service';
import { DataService } from '../../../Services/Data Service/data.service';
import { AuthService } from '../../../Auth/auth.service';
import { firstValueFrom, forkJoin, switchMap, take } from 'rxjs';
import { DisableAutocompleteDirective } from '../../../disable-autocomplete.directive';
import { FormUpdateService } from '../../../Services/Form Data/formupdate.service';
import { NAME_TITLES, normalizeUserNameTitle } from '../../../utils/name-title.util';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-g-terms-conditions',
  standalone: true,
  imports: [FormsModule, SignaturePadComponent, NgFor, NgIf, DatePipe, DisableAutocompleteDirective],
  templateUrl: './g-terms-conditions.component.html',
  styleUrl: './g-terms-conditions.component.css'
})
export class GTermsConditionsComponent {
  @Input() isViewOnly: boolean = false;
  @Input() formData: any; 
  
  // agreed: boolean = false; //was used fpr T&C checkbox- now sign and upload

  vendorDataConsentAccepted = false;
  readonly vendorDataConsentVersion = 'vendor-data-consent-v2';
  readonly vendorDataConsentText =
    'I have read, understood, and agree to be bound by the Terms and Conditions, and any other applicable policies governing the use of this portal. By checking this box and proceeding, I acknowledge and accept all such terms and conditions.';

  currentDate: any = '';
  error_message = '';

  user: any = '';
  company: any = '';

  titles: readonly string[] = NAME_TITLES;

  showFinalStepMessage = false; 

  loading = false;
  // currUser: any;
  savedMessage = '';
  exists = false;

  documents: any = '';
  vendorConsentRecord: {
    accepted: boolean;
    consentVersion: string;
    consentText: string;
    acceptedAt: string;
  } | null = null;
  vendorConsentAbsent = false;
  vendorConsentLoaded = false;

  constructor(
    private formDataService: FormDataService, 
    private dataService: DataService, 
    private formUpdateService: FormUpdateService,
    private auth: AuthService,
    private router: Router) {
    this.documents = this.formDataService.getDocumentsData(); // Retrieve existing document data
  }
  
  ngOnInit(){
    this.currentDate = new Date().toISOString().split('T')[0];
    this.user = this.formDataService.getUserData(); // Retrieve existing user data
    this.syncNameAndTitle();
    console.log("date: ", this.currentDate);

    this.showFinalStepMessage = !this.isViewOnly; //show instruction modal in edit mode

    const existingConsent = this.formDataService.getFormData()?.vendorConsent;
    if (existingConsent?.accepted === true) {
      this.vendorDataConsentAccepted = true;
    }
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['formData']){
      if (this.formData?.user) {
        this.user = this.formData.user;
        this.syncNameAndTitle();
      }
      if (this.formData?.company) {
        this.company = this.formData.company;
      }
      if (this.formData?.documents) {
        this.documents = this.formData.documents;
      }
      if (this.formData?.vendorConsentRecord) {
        this.vendorConsentRecord = this.formData.vendorConsentRecord;
      } else {
        this.vendorConsentRecord = null;
      }
      this.vendorConsentAbsent = this.formData?.vendorConsentAbsent === true;
      this.vendorConsentLoaded = this.formData?.vendorConsentLoaded === true;
    }
  }

  /** Keep honorific in strTitle and bare name in strName (repair legacy saves that merged title into strName). */
  private syncNameAndTitle(): void {
    if (!this.user || this.isViewOnly) {
      return;
    }

    const normalized = normalizeUserNameTitle(this.user);
    if (
      normalized.strName !== this.user.strName ||
      normalized.strTitle !== (this.user.strTitle ?? '')
    ) {
      this.user.strName = normalized.strName;
      this.user.strTitle = normalized.strTitle;
      this.formDataService.updateUserData(normalized);
    }
  }

  onTitleChange(title: string): void {
    this.resetErrorMessage();
    this.formDataService.updateUserData({ strTitle: title });
  }
    
  resetErrorMessage() {
    this.error_message = "";
  }

  onVendorConsentChange(accepted: boolean) {
    this.resetErrorMessage();
    this.vendorDataConsentAccepted = accepted === true;
    this.formDataService.updateFormData({
      vendorConsent: {
        accepted: this.vendorDataConsentAccepted,
        version: this.vendorDataConsentVersion,
        consentText: this.vendorDataConsentText,
      }
    });
  }

  updateSignature_fromPad(signature: File){
    this.resetErrorMessage();
    this.user.signatureFile = signature;
    console.log('Signature updated in parent:', this.user.signatureFile);
  }

  removeDocument(fileType: 'tcFile' | 'conductFile', fileInput?: HTMLInputElement): void {
    this.resetErrorMessage();

    if (fileType === 'tcFile') {
      this.documents.tcFile = null;
      this.documents.tcFilePath = null;
      this.documents.tcFileData = null;
    } else {
      this.documents.conductFile = null;
      this.documents.conductFilePath = null;
      this.documents.conductFileData = null;
    }

    if (fileInput) {
      fileInput.value = '';
    }

    this.formDataService.updateDocumentsData(this.documents);
  }

  onFileSelected(event: Event, fileType: string) {
    this.resetErrorMessage();
    const input = event.target as HTMLInputElement;
    
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
  
      // PDF LIMIT
      if (file.type !== 'application/pdf') {
        alert('Only PDF files are allowed.');
        input.value = ''; // Clear the file input
        return;
      }
  
      // FILE SIZE LIMIT
      const fileSizeLimit = 10 * 1024 * 1024; // 10 MB 
      if (file.size > fileSizeLimit) {
        alert('The file is too large. Please select a file smaller than 20 MB.');
        input.value = ''; // Clear the file input
        return;
      }

      switch (fileType) {
        case 'tcFile':
          this.documents.tcFile = file;
          break;
        case 'conductFile':
          this.documents.conductFile = file;
          break;
      }
    }
  }

  onImgSelected(event: Event) {
    this.resetErrorMessage();

    const input = event.target as HTMLInputElement;
    
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];

      //File type limit
      if (!allowedTypes.includes(file.type)) {
        alert('Please upload either a JPG or PNG image.');
        input.value = ''; 
        this.error_message = '';
        return;
      }

      // FILE SIZE LIMIT
      const fileSizeLimit = 500 * 1024; // 500 KB in bytes
      if (file.size > fileSizeLimit) {
        alert('The file is too large. Please select a file smaller than 20 MB.');
        input.value = ''; // Clear the file input
        return;
      }

      this.user.signatureFile = file;
      console.log(this.user.signatureFile)
    }
  }



  validatefields(): boolean {
    // if (!this.agreed){
    //   this.error_message = "You must agree to terms and conditions to proceed.";
    //   return false
    // }

    if (!this.user.strName?.trim()){
      this.error_message = "Name missing from signature.";
      return false
    }

    if (!this.user.strTitle?.trim()){
      this.error_message = "Please select a title.";
      return false
    }

    // if (!this.user.strPassword?.trim()){
    //   this.error_message = "Create a password to proceed.";
    //   return false
    // }
    
    if (!this.documents.tcFile && !this.documents.tcFilePath) {
      this.error_message = "Please sign and upload Terms & Conditions.";
      return false;
    }

    if (!this.documents.conductFile && !this.documents.conductFilePath) {
      this.error_message = "Please sign and upload Code of Conduct and Ethics.";
      return false;
    }

    if (!this.vendorDataConsentAccepted) {
      this.error_message = "You must accept the Terms and Conditions to proceed.";
      return false;
    }

    if (
      (!this.user.signatureFile) ||
      (typeof this.user.signatureFile === 'string' && !this.user.signatureFile.trim())
    ) {
      this.error_message = "Please sign or upload signature";
      return false;
    }
    return true;
  }


  async onSubmit(): Promise<boolean> {
    if (!this.validatefields()) {
     return false; // Validation failed
    }

    if (this.error_message !== "") {
      return false; // Error message present, do not proceed
    }

    // Save signature and title separately; strName is combined only on final registration submit
    this.formDataService.updateUserData({
      signatureFile: this.user.signatureFile,
      strTitle: (this.user.strTitle ?? '').trim(),
    });

    //Update Locally
    this.formDataService.updateDocumentsData(this.documents);
    this.formDataService.updateFormData({
      vendorConsent: {
        accepted: true,
        version: this.vendorDataConsentVersion,
        consentText: this.vendorDataConsentText,
      }
    });

    //SAVE documents and user signature TO DB
    try {
      await firstValueFrom(forkJoin([
        this.formUpdateService.updateDocuments(this.formDataService.getCurrCompanyID()),
        this.formUpdateService.updateUser(this.formDataService.getCurrCompanyID()),
      ]));
        this.loading = false;
      return true;
    } catch (error) {
      // Prefer user-friendly errors so people know what to do next.
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401 || error.status === 403) {
          this.error_message = 'Session expired. Refresh to continue.';
          this.auth.logout();
          this.router.navigate(['/login'], { queryParams: { reason: 'session-expired' } });
        } else if (error.status === 404) {
          this.error_message = 'We could not find your registration record to update. Please refresh and try again.';
        } else if (error.status >= 500) {
          this.error_message = 'Server error while saving documents. Please refresh and try again.';
        } else {
          this.error_message = "There was an issue saving documents. Please try again.";
        }
      } else {
        this.error_message = "There was an issue saving documents. Please try again.";
      }
      this.loading = false;
      return false;
    }

    return true;
  }
}
